import type { ProfileDisplayOptions } from './types';

// Query params of the embed URL: /embed?header=0&photos=1&sidebar=1
export function parseEmbedOptions(search: string, embedded: boolean): ProfileDisplayOptions {
  if (!embedded) return { header: true, photos: true, sidebar: true, embedded: false };
  const params = new URLSearchParams(search);
  const flag = (key: string, fallback: boolean) => {
    const value = params.get(key);
    if (value === null) return fallback;
    return value === '1' || value === 'true';
  };
  return { header: flag('header', false), photos: flag('photos', true), sidebar: flag('sidebar', true), embedded: true };
}
